import React from 'react';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import { ChevronLeft } from '@olxbr/ds-icons';
import * as Styles from './styles';
import { ThemeProvider } from 'styled-components';
export const calculateRotation = type => {
  switch (type) {
    case 'left':
      return 0;
    case 'up':
      return 90;
    case 'right':
      return 180;
    case 'down':
      return 270;
  }
  return 0;
};
export const getPositionedDimensions = (minWidth, minHeight, direction, width, height) => {
  switch (direction) {
    case 'up':
    case 'down':
      return {
        width: width,
        height: height,
        minWidth: minHeight,
        minHeight: minWidth
      };
    case 'right':
    case 'left':
    default:
      return {
        width: width,
        height: height,
        minWidth: minWidth,
        minHeight: minHeight
      };
  }
};
export const ArrowButton = _ref => {
  let {
    direction,
    disabled,
    color = 'default',
    width = '28px',
    height = '48px',
    expandClickableArea,
    onClick,
    'aria-label': ariaLabel
  } = _ref;
  const minWidth = '28px';
  const minHeight = '48px';
  const themeColor = color === 'inverted' ? 'inverted' : 'default';
  const rotation = calculateRotation(direction);
  const dimensions = getPositionedDimensions(minWidth, minHeight, direction, width, height);
  const handleClick = event => {
    event.stopPropagation();
    event.preventDefault();
    onClick && onClick(event);
  };
  return React.createElement(ThemeProvider, {
    theme: Styles.themes[themeColor]
  }, React.createElement(Styles.ArrowButtonWrapper, {
    "data-ds-component": "DS-ArrowButton",
    rotation: rotation,
    dimensions: dimensions,
    direction: direction,
    expandClickableArea: expandClickableArea,
    onClick: handleClick,
    disabled: !!disabled,
    color: color,
    "aria-label": ariaLabel
  }, React.createElement(ChevronLeft, null)));
};
ArrowButton.displayName = 'ArrowButton';